import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { AREA, CITY, LOCATION_TYPE, PIN_CODE, STATE, ZONE, SHIP_PIN_CODE } from "./type";

export const locationCity = () => async (dispatch) => {
  const res = await callWebService(callTypes.get, "", Config.locations.city);
  if (res) {
    const { data } = res;
    dispatch({ type: CITY, payload: data.response.data });
    return true;
  }
};

export const locationZone = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.locations.zone}${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: ZONE, payload: data.response.data });
    return true;
  }
};

export const locationArea = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.locations.area}${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: AREA, payload: data.response.data });
    return true;
  }
};

export const locationState = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.locations.state}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: STATE, payload: data.response.data });
    return true;
  }
};

export const locationType = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.locations.locationType
  );
  if (res) {
    const { data } = res;
    dispatch({ type: LOCATION_TYPE, payload: data.response?.data ?? data.data });
    return true;
  }
};

export const locationPinCode = (pinNumber) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.locations.pinCode}${pinNumber}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: PIN_CODE, payload: data.response.data });
    return true;
  }
};

export const shipTolocationPinCode = (pinNumber) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.locations.pinCode}${pinNumber}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SHIP_PIN_CODE, payload: data.response.data });
    return true;
  }
};
